<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bOjH1l/tc-custom/9781646042197.jpg?1729379439493" alt="This image is the cover for the book Hard Seltzer Cocktail Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hard Seltzer Cocktail Book
      </h1>
      <p class="bookDescription body article font2">
        <b>The original cocktail book designed to make your favorite bubbly, boozy beverage that much boozier—includes over fifty sparkling recipes.</b><br/><br/>From sparkling Cosmos and daiquiris to a twist on the ever-popular Aperol spritz, make every season hard seltzer season! The wildly popular sparkling beverage is a tasty, low-cal treat on its own . . . but sometimes you have to take it up a notch (or several). <i>The Hard Seltzer Cocktail Book</i> offers everything you need to add a little snap, sparkle, and pop to your favorite cocktails. Whether you’re team White Claw, a Truly follower, or a Bud Light Seltzer fan, there’s something for everyone with these easy-to-make recipes, including: <br/><br/>Sparkling Frose * Poppin’ Lemon Drops * Watermelon Sugar Slushies * One-Minute Margs * Summer in Moscow Mules * Fizzy Fuzzy Navels * and more<br/><br/>These fifty-five recipes are designed to get the party started, whether it’s a Friday night pregame or it's just been a tough day. Instead of that next round of always-regrettable tequila shots, pick up this book—and get bubbly.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Casie Vogel
      </h2>
      
      <p class="authorDescription body article">Casie Vogel is a lover of all things carbonated,&#160;whether it&#39;s a spiked seltzer happy hour or her daily&#160;Diet Coke.&#160;She has experience both hosting and attending many a boozy brunch that has transitioned into all-night affairs, thanks to well-mixed drinks. She lives in Brooklyn.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3058bd75